import { createContext, useContext } from "react";
import type { SessionSnapshot } from "./types";

/**
 * 認証セッションを SPA 全体へ配布するための Context。
 *
 * - `user`: 現在の SessionSnapshot。未復元・未ログインの場合は undefined。
 * - `isRestoring`: 起動直後の IndexedDB 復元処理中フラグ。
 * - `signOut`: SDK サブツリー側へサインアウト要求を伝える。
 */
export interface AuthSessionContextValue {
  readonly user: SessionSnapshot | undefined;
  readonly isRestoring: boolean;
  readonly signOut: () => Promise<void>;
}

export const AuthSessionContext = createContext<AuthSessionContextValue | null>(null);

export function useAuthSession(): AuthSessionContextValue {
  const value = useContext(AuthSessionContext);
  if (value === null) {
    throw new Error("useAuthSession は AuthShell 配下から呼び出してください。");
  }
  return value;
}
